var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbsUpFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.29248 13.9227V6.30272C6.29248 6.00272 6.38248 5.71022 6.54748 5.46272L8.59498 2.41772C8.91748 1.93022 9.71998 1.58522 10.4025 1.84022C11.1375 2.08772 11.625 2.91272 11.4675 3.64772L11.0775 6.10022C11.0475 6.32522 11.1075 6.52772 11.235 6.68522C11.3625 6.82772 11.55 6.91772 11.7525 6.91772H14.835C15.4275 6.91772 15.9375 7.15772 16.2375 7.57772C16.5225 7.98272 16.575 8.50772 16.3875 9.04022L14.5425 14.6577C14.31 15.5877 13.2975 16.3452 12.2925 16.3452H9.36748C8.86498 16.3452 8.15998 16.1727 7.83748 15.8502L6.87748 15.1077C6.50998 14.8302 6.29248 14.3877 6.29248 13.9227Z",
    fill: "#7D7E80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9075 4.83984H3.135C1.9725 4.83984 1.5 5.28984 1.5 6.39984V13.9448C1.5 15.0548 1.9725 15.5048 3.135 15.5048H3.9075C5.07 15.5048 5.5425 15.0548 5.5425 13.9448V6.39984C5.5425 5.28984 5.07 4.83984 3.9075 4.83984Z",
    fill: "#7D7E80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUpFilled);
export default __webpack_public_path__ + "static/media/ThumbsUpFilled.4ba482b6a760d2e225cea15ec9048ce5.svg";
export { ForwardRef as ReactComponent };